import { decryptData, encryptData } from "utils/dataCipherHelper";
import { instance as axios, setHeaders } from "../config/axiosInstance";

// get  notification list handler api
export const fetchUserNotificationApi = async (data) => {
  const responseData = await axios.get(
    `notification/user-notification-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};
